import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { BillingRateEffects } from 'src/app/margin-calculator/store/effects/billing-rate-effects';
import { ContractMinDaysEffects } from 'src/app/margin-calculator/store/effects/contract-min-days.effects';
import { MarginCalculatorEffects } from 'src/app/margin-calculator/store/effects/margin-calculator.effects';
import { marginCalculatorReducer } from 'src/app/margin-calculator/store/reducers/margin-calculator.reducer';
import { marginCalculatorFeatureKey } from 'src/app/margin-calculator/store/selectors';
import { PayRateEffects } from 'src/app/margin-calculator/store/effects/pay-rate.effects';
import { UpdateMarginEffects } from 'src/app/margin-calculator/store/effects/update-margin.effects';
import { HousingEffects } from 'src/app/margin-calculator/store/effects/housing.effects';

@NgModule({
    imports: [
        CommonModule,
        StoreModule.forFeature(marginCalculatorFeatureKey, marginCalculatorReducer),
        EffectsModule.forFeature([
            MarginCalculatorEffects,
            ContractMinDaysEffects,
            BillingRateEffects,
            PayRateEffects,
            UpdateMarginEffects,
            HousingEffects
        ])
    ]
})
export class MarginCalculatorStoreModule {}
